import { ClientManagementButtonAdd } from './ButtonAdd';

export const ButtonAdd = ClientManagementButtonAdd;
